import { REGION } from "./actionTypes";
import { REGIONS_URL } from "../../helpers/url_api_helper";
import { getListaRegion, getRegion, saveRegion,  } from "./actions";
import moment from "moment";
import { emptyStringToNull } from "../../helpers/null_empty_string_helper";
import { call, put, takeEvery } from "redux-saga/effects";
import { normalizeApiError } from "../../helpers/utils/normalizeApiError";

function* listarRegions({ payload }) {
    const filterRegion = payload;
    
    try {
        emptyStringToNull(filterRegion);
        const res = yield call(REGIONS_URL.getRegionsLista, filterRegion);
        yield put(getListaRegion.success(res));
    } catch (error){
        yield put(getListaRegion.fail(normalizeApiError(error, "ERROR")));
    }
}

function* salvarRegion({ payload }) {
    const { body, method } = payload;
    try {
        if (method === "POST") {
            yield call(REGIONS_URL.postRegion, body);
            yield put(saveRegion.success(true));
        } else {
            yield call(REGIONS_URL.putRegion, body);
            yield put(saveRegion.success(true));
        }    
    } catch (error) {
        yield put(saveRegion.fail(normalizeApiError(error, "Something went wrong saving the region, please try again later")));
    }
};

function* obterRegion({ payload }) {
    const { regionId } = payload;
    try {
        const res = yield call(REGIONS_URL.getRegion, regionId);
        
        res.activeStatus = res.active === true ? ["Active Status"] : [];
        res.createDate = moment(res.createDate).format("DD MMM/YY hh:mm A").toString() 
        res.updateDate = res.updateDate !== null ? moment(res.updateDate).format("DD MMM/YY hh:mm A").toString() : "";
        
        yield put(getRegion.success(res));
    } catch (error){
        yield put(getRegion.fail(normalizeApiError(error, "ERROR")));
    }
}

function* RegionSaga() {
    yield takeEvery(REGION.GET_LIST.REQUEST, listarRegions);
    yield takeEvery(REGION.SAVE_ITEM.REQUEST, salvarRegion);
    yield takeEvery(REGION.GET_ITEM.REQUEST, obterRegion);
}

export default RegionSaga;